import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { PacsDtoKeysEnum } from '@zaoblako/shared/modules/pacs/enums/pacs-dto-keys.enum';

import * as yup from 'yup';

/** Converter cards reading settings response body */
export interface ConverterReadCardsFindInterface {
  /** Last card reading command run date and time */
  lastRun?: Date;
  /** Number cards on device */
  countCards?: number;
}

/** Converter cards reading settings response body - DTO schema */
export const ConverterReadCardsFindDto = SerdeDtoClass.create<ConverterReadCardsFindInterface>(PacsDtoKeysEnum.CONVERTER_READ_CARDS_FIND_DTO, {
  lastRun: {
    optional: true,
    label: 'Дата и время последней синхронизации',
    serializer: yup.date(),
  },
  countCards: {
    optional: true,
    label: 'Количество карт, записанных в память устройства',
    serializer: yup.number(),
  },
});
